/**
 * Clears stored session and sends the user to login when the API returns 401.
 * Skips redirect on public auth routes to avoid interrupting sign-in / sign-up flows.
 */
export function clearSessionAndRedirectToLogin(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  const path = window.location.pathname;
  if (path === "/login" || path === "/signup" || path.startsWith("/forgot-password")) {
    return;
  }
  window.location.assign("/login");
}

/** Use instead of raw `fetch` for API calls that may return 401 when the JWT expires. */
export async function fetchWithAuth(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const response = await fetch(input, init);
  if (response.status === 401) {
    clearSessionAndRedirectToLogin();
  }
  return response;
}
